export default "__VITE_ASSET__9ClZMbu8__"